module.exports = __webpack_public_path__ + "static/media/Coach_x_MBJ_Module_bg.9e50a2d6.png";